<app-modal>
  <app-modal-title>{{ 'modal.project-photo-view.title' | translate }}</app-modal-title>
  <app-modal-body>
    <div class="flex justify-center">
      <div class="bg-white h-64 aspect-video flex items-center justify-center relative">
        <app-loader></app-loader>

        <img class="object-contain object-center inset-0 absolute h-full w-full" [attr.src]="projectPhoto | projectPhotoPreview | async">
      </div>
    </div>
  </app-modal-body>
  <app-modal-footer>
    <app-button text="{{ 'modal.project-photo-view.close' | translate }}" variant="plain" (click)="close()"></app-button>
    <app-button text="{{ 'modal.project-photo-view.download' | translate }}" [loading]="loading" (click)="download()"></app-button>
  </app-modal-footer>
</app-modal>
